import React, { useState, useEffect } from "react";
import "./Services.css";
import { Link } from "react-router-dom";
const Services = () => {
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");
    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  return (
    <div class="container okjhgt">
      <h1>{rtl ? "خدماتنا" : fr ? "Nos services" : "Our Services"}</h1>
      <img
        src={require("../../Assets/pshape.png")}
        alt="shape"
        // class="shape"
        style={{ marginTop: "10px" }}
      />
      <p>
        {rtl
          ? "ما يمكنك العثور عليه في شركتنا"
          : fr
          ? "Ce Que Vous Pouvez Trouver Dans Notre Société"
          : "What You Can Find in Our Holding"}
      </p>
      <div class="services">
        <div class="service-card">
          <div class="service-image">
            <img
              src={require("../../Assets/oil-and-gas-services.jpg")}
              alt="oil&gas"
              class="card-img"
            />
            <img
              src={require("../../Assets/gas.png")}
              alt="oil and gas"
              class="icon"
            />
          </div>
          <Link to="/services">
            <div>
              <h6>
                {rtl ? "النفط و الغاز" : fr ? "Pétrole et Gaz" : "Oil & Gas"}
              </h6>
              <p></p>
            </div>
          </Link>
        </div>
        <div class="service-card">
          <div>
            <img
              src={require("../../Assets/investment-service.jpg")}
              alt="Investments"
              class="card-img"
            />
            <img
              src={require("../../Assets/inves.png")}
              alt="oil and gas"
              class="icon"
            />
          </div>
          <Link to="/services">
            <div>
              <h6>
                {rtl ? "الاستثمارات" : fr ? "Investissements" : "Investments"}
              </h6>
              <p></p>
            </div>
          </Link>
        </div>
        <div class="service-card">
          <div>
            <img
              src={require("../../Assets/consumer-service.jpeg")}
              alt="consumer-services"
              class="card-img"
            />
            <img
              src={require("../../Assets/realstate.png")}
              alt="oil and gas"
              class="icon"
            />
          </div>
          <Link to="/services">
            <div>
              <h6>
                {rtl
                  ? "المستهلك و العقارات"
                  : fr
                  ? "Consommation et Immobilier"
                  : "Consumer & Real Estate"}
              </h6>
              <p></p>
            </div>
          </Link>
        </div>
        <div class="service-card">
          <div>
            <img
              src={require("../../Assets/information-technology.jpg")}
              alt="information-technology"
              class="card-img"
            />
            <img
              src={require("../../Assets/it.png")}
              alt="oil and gas"
              class="icon"
            />
          </div>
          <Link to="/services">
            <div>
              <h6>
                {rtl
                  ? "تكنولوجيا المعلومات"
                  : fr
                  ? "Technologies de L'information"
                  : "Information Technology"}
              </h6>
              <p></p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Services;
